var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$x.root }, [
    !_vm.adrOnly
      ? _c(
          "div",
          {
            class: [_vm.$x.row, _vm.$x.wrap],
            attrs: {
              itemprop: "offers",
              itemscope: "",
              itemtype: "http://schema.org/Offer",
            },
          },
          [
            _vm.showOriginal
              ? [
                  _c(
                    "div",
                    {
                      class: [
                        _vm.$x.row,
                        _vm.$x.wrap,
                        _vm.$x.marginBottom,
                        _vm.$x.strikeThrough,
                      ],
                    },
                    [
                      _vm.showLabels && _vm.originalPriceLabel
                        ? _c("span", { class: _vm.$x.label }, [
                            _vm._v(_vm._s(_vm.originalPriceLabel + " ")),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("NsCurrency", {
                        class: _vm.$x.price,
                        attrs: {
                          amount: _vm.originalPrice,
                          "price-type": _vm.originalPriceType,
                          itemprop: "price",
                          "data-testid": "original-price",
                          "strike-through": "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: [_vm.$x.row, _vm.$x.wrap, _vm.$x.marginBottom] },
              [
                _vm.showLabels && _vm.priceLabel
                  ? _c("span", { class: _vm.$x.label }, [
                      _vm._v(_vm._s(_vm.priceLabel + " ")),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("NsCurrency", {
                  class: _vm.$x.price,
                  attrs: {
                    amount: _vm.isBaseSku ? _vm.minPrice : _vm.price,
                    "price-type": _vm.priceType,
                    itemprop: "price",
                    "data-testid": _vm.isBaseSku ? "min-price" : "price",
                  },
                }),
                _vm._v(" "),
                _vm.showMinMax
                  ? _c("span", { class: _vm.$x.priceSeparator }, [_vm._v("-")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showMinMax
                  ? _c("NsCurrency", {
                      class: _vm.$x.price,
                      attrs: {
                        amount: _vm.maxPrice,
                        "price-type": _vm.priceType,
                        itemprop: "price",
                        "data-testid": "max-price",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showAdr
      ? _c(
          "div",
          { class: [_vm.$x.row, _vm.$x.marginBottom] },
          [
            _vm.adrPriceLabel
              ? _c("span", { class: _vm.$x.label }, [
                  _vm._v(_vm._s(_vm.adrPriceLabel + " ")),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("NsCurrency", {
              class: _vm.$x.price,
              attrs: {
                amount: _vm.adrPrice,
                "price-type": _vm.adrPriceType,
                itemprop: "price",
                "data-testid": "adr-price",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }